











import Vue from 'vue';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { Getter } from 'vuex-class';
import Component from 'vue-class-component';
import { FORM_LOADING_MODE } from '@/types/form.types';

@Component({})
export default class FormLoading extends Vue {
  @Getter(FORM_LOADING_MODE, StoreNamespace.FORM) public formLoadingMode!: boolean;
}

